import React, { Component } from "react";
import {
  Map,
  InfoWindow,
  Marker,
  GoogleApiWrapper,
  Polyline,
  GoogleAPI,
} from "google-maps-react";

import { Card, CardTitle, Table } from "reactstrap";
import getLiveVehicleTrack from "../../services/livevehicletrack";

export class MapContainer extends Component {
  state = {
    showingInfoWindow: false,
    activeMarker: {},
    selectedPlace: {},
    selectedVechile: {},
    triangleCoords: [],
  };

  intervalId;

  onMarkerClick = (props, marker, e) => {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true,
    });
  };

  onMapClicked = () => {
    if (this.state.showingInfoWindow) {
      this.setState({
        showingInfoWindow: false,
        activeMarker: null,
      });
    }
  };

  componentDidMount() {
    const { vid } = this.props.selectedVechile.location.data;
    this.iterateRequest(vid);
  }

  iterateRequest(vid) {
    this.intervalId = setInterval(async () => {
      const response = await getLiveVehicleTrack(vid);
      const tempLocation = this.state.triangleCoords.concat({
        lat: parseFloat(parseFloat(response.lat).toFixed(3)),
        lng: parseFloat(parseFloat(response.lnt).toFixed(3)),
      });
      this.setState({
        selectedVechile: response,
        triangleCoords: tempLocation,
      });
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  render() {
    const selectedVechile = this.props.selectedVechile.location.data;
    const localSelectedVechile =
      this.state.selectedVechile.lat === undefined
        ? selectedVechile
        : this.state.selectedVechile;
    return (
      <>
        <div style={{ height: "600px", alignContent: "center" }}>
          <Map
            google={this.props.google}
            onClick={this.onMapClicked}
            containerStyle={{ height: "600px", width: "90%" }}
            zoom={14}
            initialCenter={{
              lat: localSelectedVechile.lat,
              lng: localSelectedVechile.lng ?? localSelectedVechile.lnt,
            }}
            center={{
              lat: localSelectedVechile.lat,
              lng: localSelectedVechile.lng ?? localSelectedVechile.lnt,
            }}
          >
            {this.state.triangleCoords.map((marker) => (
              <Marker
                animation={2}
                onClick={this.onMarkerClick}
                title={"The marker`s title will appear as a tooltip."}
                name={
                  <div>
                    <ul>vid :{localSelectedVechile.vd ?? ""}</ul>
                    <ul>Speed :{localSelectedVechile.spd ?? ""}</ul>
                    <ul>LastUpdate :{localSelectedVechile.tsp ?? ""}</ul>
                    <ul>vtype :{localSelectedVechile.vtp ?? ""}</ul>
                    <ul>odometer :{localSelectedVechile.odo ?? ""}</ul>
                  </div>
                }
                position={{
                  lat: localSelectedVechile.lat,
                  lng: localSelectedVechile.lnt,
                }}
              />
            ))}

            <InfoWindow
              marker={this.state.activeMarker}
              visible={this.state.showingInfoWindow}
            >
              <div>{this.state.selectedPlace.name}</div>
            </InfoWindow>
            <Polyline
              path={this.state.triangleCoords}
              strokeColor="#0000FF"
              strokeOpacity={0.8}
              strokeWeight={2}
            />
          </Map>
        </div>
        <Table className="align-items-center table-dark mt-4 " responsive>
          <thead className="thead-dark">
            <tr>
              <th scope="col">vid</th>
              <th scope="col">Speed</th>
              <th scope="col">LastUpdate</th>
              <th scope="col">vtype</th>
              <th scope="col">odometer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{localSelectedVechile.vd ?? "loading..."}</td>
              <td>{localSelectedVechile.spd ?? "loading..."}</td>
              <td>{localSelectedVechile.tsp ?? "loading..."}</td>
              <td>{localSelectedVechile.vtp ?? "loading..."}</td>
              <td>{localSelectedVechile.odo ?? "loading..."}</td>
            </tr>
          </tbody>
        </Table>

        <div className="p-2"></div>
      </>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyArpzS5JA0kvLuWIWBnfTl4du8eIhJIoU4",
})(MapContainer);
